
export default {
  name: 'MeatPageSwiper',
  inheritAttrs: false,
  props: {
    options: {
      type: Object,
      default: () => ({})
    },
    controlsOnlyMobile: {
      type: Boolean,
      default: false
    }
  },
  head() {
    return {
      script: [
        {
          hid: 'swiper-element',
          src: '/meat/lib/swiper-element-bundle.min.js',
        }
      ]
    }
  },
  watch: {
    options: {
      handler() {
        this.updateSwiper();
      },
      deep: true
    }
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    this.dispose();
  },
  methods: {
    init() {
      const swiperEl = this.$refs.swiperRef;
      if (!swiperEl || swiperEl.initialized) return;

      const options = {
        ...this.options,
        navigation: {
          prevEl: this.$refs.prevEl,
          nextEl: this.$refs.nextEl,
          ...this.options.navigation,
        },
        pagination: {
          el: this.$refs.paginationEl,
          clickable: true,
          ...this.options.pagination,
        }
      };

      Object.assign(swiperEl, options);
      swiperEl.initialize();
    },
    updateSwiper() {
      this.$nextTick(() => {
        const swiperEl = this.$refs.swiperRef;
        if (swiperEl && swiperEl.swiper) {
          swiperEl.swiper.update();
        }
      });
    },
    dispose() {
      const swiperEl = this.$refs.swiperRef;
      if (!swiperEl?.swiper) return;

      swiperEl.swiper.destroy(true, true);
    }
  }
}
